var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-7 mb-5"},[_c('user-profile-information'),_c('user-teams-and-services'),_c('users-in-teams'),_c('invitation-requests'),_c('team-history')],1)}
var staticRenderFns = []

export { render, staticRenderFns }